// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.image-container[data-v-39a90ab0]{\n  margin-bottom:0.5rem;\n  padding-left:0.75rem;\n  padding-right:0.75rem\n}\n@media (min-width: 768px){\n.image-container[data-v-39a90ab0]{\n    margin-bottom:0.75rem\n}\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
